import React from 'react';

const NebulaTradingTransactionFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaTradingTransactionModalRegistry = {
    personalize_nebulaTradingTransactionId: NebulaTradingTransactionFormModal
};
export default nebulaTradingTransactionModalRegistry;
